import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import api from './api/axios';

window.Pusher = Pusher;

let echoInstance = null;

export function initEcho() {
    if (echoInstance) return echoInstance;

    echoInstance = new Echo({
        broadcaster: 'reverb',
        key: process.env.REACT_APP_REVERB_APP_KEY,
        wsHost: process.env.REACT_APP_REVERB_HOST,
        wsPort: process.env.REACT_APP_REVERB_PORT ?? 443,
        wssPort: process.env.REACT_APP_REVERB_PORT ?? 443,
        forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        channelAuthorization: {
            customHandler: ({ socketId, channelName }, callback) => {
                api.post('/broadcasting/auth', {
                    socket_id: socketId,
                    channel_name: channelName,
                })
                    .then((response) => callback(null, response.data))
                    .catch((err) => callback(err, { auth: '' }));
            },
        },
    });

    return echoInstance;
}

export function getEcho() {
    return echoInstance;
}

export function disconnectEcho() {
    if (echoInstance) {
        echoInstance.disconnect();
        echoInstance = null;
    }
}
